<template>
  <a-layout>
    <a-layout-header id="hm-header">
      <div class="hm-header-content">
        <div class="hm-header-company" @click="index">
          {{ headerObj.companyName }}
        </div>
        <div class="hm-head-right">
          <div class="hm-menu">
            <div
              v-for="(item, index) in headerObj.menuList"
              :key="index"
              @click="change(item)"
              :class="[item.id == selectId ? 'select-class' : '']"
              class="page-title"
            >
              {{ item.menuName }}
            </div>
          </div>
          <div class="hm-header-btn">
            <a-popover placement="bottom">
              <template slot="content">
                <a-tabs defaultActiveKey="1" @change="callback">
                  <a-tab-pane tab="通知" key="1">
                    <div
                      class="notify-item"
                      v-for="(item, index) in headerObj.notifys"
                      :key="index"
                    >
                      <div class="notify-item-top">
                        <span class="notify-item-title">{{ item.title }}</span>
                        <span class="notify-item-date">{{ item.date }}</span>
                      </div>
                      <p>{{ item.content }}</p>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane tab="消息" key="2"
                    >Content of Tab Pane 2</a-tab-pane
                  >
                </a-tabs>
              </template>
              <a-icon class="hm-header-notify" @click="notify" type="bell" />
            </a-popover>

            <img class="hm-header-user-icon" :src="headerObj.userIcon" />

            <span class="hm-header-user-name" @click="login" v-if="!isLogin"
              >登录</span
            >
            <a-popover v-model="showConfirm" >
              <template slot="content">
                <div style="margin-bottom: 5px; backgroudcolor: black">
                  <a-button
                    style="border: none; padding: 0"
                    @click.stop="handleLogout"
                    ><a-icon type="logout" />&nbsp;退出登录
                  </a-button>
                </div>
                <div>
                  <a-button
                    style="border: none; padding: 0"
                    @click.stop="userMessage"
                    ><a-icon type="user" />&nbsp;个人信息
                  </a-button>
                </div>
              </template>
              <span class="hm-header-user-name" v-if="isLogin">{{
                headerObj.userName
              }}</span>
            </a-popover>
          </div>
        </div>
      </div>
    </a-layout-header>
  </a-layout>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "HmHeader",
  props: {
    headerObj: {
      type: Object,
    },
  },
  data() {
    return {
      showConfirm: false,
      selectId: 0,
      showConfirm: false,
      isLogin: this.getUserId == undefined ? false : true,
    };
  },
  //监听userid是否变化
  watch: {
    getUserId(val) {
      this.isLogin = val == undefined ? false : true;
    },
    getUserName(val) {
      this.headerObj.userName = val;
    },
    // showConfirm(val) {
    //   let that = this;
    //   if (val) {

    //   }
    // },
  },
  //获取userid
  computed: {
    ...mapGetters(["getUserId", "getUserName"]),
  },
  mounted() {
    var test =  window.location.pathname;
    if (test=='/project/list'){
      this.selectId =1
    }else if (test =='/all-page'){
      this.selectId =2
    }else if (test =='/all-component'){
      this.selectId =3
    }else if (test =='/product/index'){
      this.selectId =4
    }
    // console.log('this.headerObj',this.headerObj)
  },
  methods: {
    ...mapActions(["Logout"]),
    change({ id, path }) {
      console.log("item", id, path);
      this.selectId = id;
      this.$router.push(path);
      console.log("this.$router", this.$router);
      this.visible = false;
    },
    index() {
      this.$router.push({ path: "/" });
    },
    notify() {},
    login() {
      this.$router.push({ path: "/login" });
    },
    callback() {},
    handleLogout() {
      const that = this;
      that.showConfirm = false;
      that.$confirm({
        okType: "warning",
        title: "提示",
        content: "真的要注销登录吗?",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          that.Logout();
        },
        onCancel() {},
      });
    },
    userMessage() {

      this.$router.push({
        path: "/user-message/index",
      });
    },
  },
};
</script>

<style scoped>
#hm-header {
  background-color: #000407;
  width: 100%;
  height: 86px;
  margin: 0;
}
#hm-header .hm-header-content {
  width: 1400px;
  height: 100%;
  line-height: 86px;
  /*background-color: orangered;*/
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
#hm-header .hm-header-company {
  color: #fff;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  cursor: pointer;
}
#hm-header .hm-header-btn {
  color: #fff;
}
#hm-header .hm-header-search {
  font-size: 20px;
  margin: 0 15px;
  vertical-align: middle;
}
#hm-header .hm-header-notify {
  font-size: 20px;
  margin: 0 15px;
  vertical-align: middle;
}
#hm-header .hm-header-user-icon {
  width: 32px;
  width: 32px;
  margin: 0 10px;
  border-radius: 50%;
  cursor: pointer;
}
#hm-header .hm-header-user-name {
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}
#hm-header .notify-item {
  width: 100%;
  height: 100px;
  background-color: #fd4734;
  border-bottom: 1px solid #d9d9d9;
}
#hm-header .notify-item-top {
  height: 40px;
  width: 100%;
  /*display: flex;*/
  /*justify-content: space-between;*/
}
.notify-item-title {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #666666;
}
.notify-item-date {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
}

/deep/ .ant-tabs {
  width: 392px;
}
/deep/ .ant-tabs-content {
  width: 392px;
}

.hm-menu {
  display: flex;
  font-size: 20px;
  color: #999999;
  margin-right: 20px;
}

.page-title {
  padding: 0 20px;
  cursor: pointer;
  /* line-height: 60px; */
}
.select-class {
  color: #ffffff;
}
.hm-head-right {
  display: flex;
}
</style>